import { MAX_QUESTION_LENGTH } from './constants'
import { SlideQuestionErrorKeys } from './keys'
import { type ValidationError, type Validator } from './types'

export const validateMultipleChoice: Validator = async (context, question) => {
  const errors: ValidationError[] = []
  const trimmedQuestion = question.question?.trim()

  if (!trimmedQuestion) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_multiple_choice_missing,
    })
  } else if (trimmedQuestion.length > MAX_QUESTION_LENGTH) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_multiple_choice_too_long,
    })
  }

  const nonEmptyAnswers = question.answers?.filter((a) => a.trim() !== '') || []

  if (nonEmptyAnswers.length === 0) {
    errors.push({
      field: 'answers',
      key: SlideQuestionErrorKeys.question_multiple_choice_no_answers,
    })
  }

  const correct = question.correct
  if (
    correct !== undefined &&
    (typeof correct !== 'number' ||
      correct < 0 ||
      correct >= nonEmptyAnswers.length)
  ) {
    errors.push({
      field: 'correct',
      key: SlideQuestionErrorKeys.question_multiple_choice_correct_invalid,
    })
  }

  return errors
}
